module.exports = __webpack_public_path__ + "static/media/mobile.c43f33d3.jpg";